import { AppData } from "../../types";
import { postRequestWrapper } from "../../utilities";

export type createAppResponse = AppData;

type createAppBody = {
  name: string;
  country_code: string;
};

export function createApp(body: createAppBody): Promise<createAppResponse> {
  return postRequestWrapper<createAppBody, createAppResponse>({
    url: `${ENV_SETTINGS.API_URL}/apps`,
    body,
  });
}
